// Default Elevations
//
// Inspired by https://material.io/design/environment/elevation.html#default-elevations

export const ELEVATION_NOTIFICATION = 2000;

export const ELEVATION_POPUP = 8;
export const ELEVATION_TOP_NAVIGATION = 7;
export const ELEVATION_BOTTOM_NAVIGATION = 7;
export const ELEVATION_DISABLED_OVERLAY = 6;
export const ELEVATION_SIDEBAR = 3;
export const ELEVATION_STICKY_HEADER = 5;
export const ELEVATION_LOADER_OVERLAY = 1;
export const ELEVATION_DRAG_AND_DROP = 1;
export const ELEVATION_DROPDOWN = 3;
export const ELEVATION_FOOTER = 3;
export const ELEVATION_MAIN_CONTENT = 0;
// Lifts the header above the sidebar to show the bottom shadow
export const ELEVATION_SIDEBAR_HEADER = 1;

const colorBlackAlpha05 = 'rgba(0, 0, 0, 0.05)';
const colorBlackAlpha08 = 'rgba(0, 0, 0, 0.08)';
const colorBlackAlpha16 = 'rgba(0, 0, 0, 0.16)';
const colorBlackAlpha20 = 'rgba(0, 0, 0, 0.20)';

export const SHADOW_POPUP = `0 2px 9px 0 ${colorBlackAlpha20}, 0 0 3px 0 ${colorBlackAlpha05}`;
export const SHADOW_DROPDOWN = `0 2px 4px 0 ${colorBlackAlpha16}`;
export const SHADOW_HEADER = `0 0 10px 0 ${colorBlackAlpha05}`;
export const SHADOW_STICKY_TABLE_HEADER = `0 2px 1px ${colorBlackAlpha05}`;
export const SHADOW_SIDEBAR_HEADER = `0 1px 4px ${colorBlackAlpha08}`;
